"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushConsent = exports.pushGaEvent = exports.pushToDataLayer = exports.handleGtmEvents = void 0;
const query_string_1 = __importDefault(require("query-string"));
var ClientType;
(function (ClientType) {
    ClientType["IOS"] = "iOS App";
    ClientType["ANDROID"] = "Android App";
    ClientType["WEB"] = "Web App";
})(ClientType || (ClientType = {}));
const handleGtmEvents = (pagePath) => {
    const gaEvents = [];
    const parsed = query_string_1.default.parseUrl(pagePath, {
        parseFragmentIdentifier: true,
    });
    if (parsed.query.gtmEvents) {
        const events = parsed.query.gtmEvents instanceof Array
            ? parsed.query.gtmEvents
            : [parsed.query.gtmEvents];
        for (const event of events) {
            if (/^[a-zA-Z0-9_]{1,}-register$/.test(event)) {
                gaEvents.push({
                    category: "Account",
                    action: "Registered",
                    label: event.split("-")[0],
                });
            }
            else if (/^[a-zA-Z0-9_]{1,}-subscribed-(success|cancel)$/.test(event)) {
                gaEvents.push({
                    category: "Account",
                    action: event.endsWith("-subscribed-success")
                        ? "Subscribed Success"
                        : "Subscribed Cancel",
                    label: event.split("-")[0],
                });
            }
            else if (/^[a-zA-Z0-9_]{1,}-wellstar-(success|cancel)$/.test(event)) {
                gaEvents.push({
                    category: "Account",
                    action: event.endsWith("-wellstar-success")
                        ? "Wellstar Success"
                        : "Wellstar Cancel",
                    label: event.split("-")[0],
                });
            }
        }
        delete parsed.query.gtmEvents;
    }
    return { gaEvents, pagePath: query_string_1.default.stringifyUrl(parsed) };
};
exports.handleGtmEvents = handleGtmEvents;
const pushToDataLayer = (data, keepValues) => {
    const isIos = /iPad|iPhone/.test(navigator.userAgent);
    const isExpo = !!window.KvixApp;
    const clientType = isExpo
        ? isIos
            ? ClientType.IOS
            : ClientType.ANDROID
        : ClientType.WEB;
    window.dataLayer.push(Object.assign(Object.assign({}, data), { clientType }));
    if (!keepValues) {
        window.dataLayer.push(Object.keys(Object.assign({}, data)).reduce((acc, key) => {
            acc[key] = undefined;
            return acc;
        }, {}));
    }
};
exports.pushToDataLayer = pushToDataLayer;
const pushGaEvent = (event) => {
    (0, exports.pushToDataLayer)({
        event: "gaEvent",
        gaEvent: Object.assign({ label: "", value: 1, nonInteraction: false }, event),
    });
};
exports.pushGaEvent = pushGaEvent;
const pushConsent = () => {
    (0, exports.pushToDataLayer)({ event: "consentUpdate" });
};
exports.pushConsent = pushConsent;
//# sourceMappingURL=gtm-tracking.js.map